import { END_LOADING, START_LOADING } from "../constants/actionTypes";
import { END_LOADING_ORDERS, ENTER_BILLING_DETAILS, ENTER_ORDER_DETAILS, GET_SUPPLIER_ORDERS, OPTIONS, START_LOADING_ORDERS } from "../constants/orderConstants";


const user = JSON.parse(localStorage.getItem('profile'))


const initialState = {
    orderDetails: [{}],
    supplierOrders: [],
    billingFormDetails: {
        primaryAddress: '',
        secondaryAddress: null,
        pinCode: '',
        mobileNumber: user?.result?.mobileNumber,
    },
    billingDetails:{},
    isLoading: false,
    options : {}
}


const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case ENTER_ORDER_DETAILS:
            return { ...state, orderDetails: action.payload };
        case ENTER_BILLING_DETAILS:
            return { ...state, billingFormDetails: action.payload };
        case GET_SUPPLIER_ORDERS:
            return { ...state, supplierOrders: action.payload };
        case OPTIONS:
            // console.log(action.payload)
            return { ...state, options: action.payload };
        case START_LOADING_ORDERS:
            return { ...state, isLoading: true }
        case END_LOADING_ORDERS:
            return { ...state, isLoading: false }
        default:
            return state;
    }
}

export default orderReducer